import ViewProduct from '@/views/ViewProduct.vue'
import ViewProfile from '@/views/ViewProfile.vue'
import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Layouts from '../views/Layouts.vue'

import Login from '../views/Login.vue'
import ViewHome from '../views/ViewHome.vue'
import ViewIssue from '../views/ViewIssue.vue'
import ViewOpcBlock from '../views/ViewOpcBlock.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/',
        name: 'layouts',
        redirect: 'issue',
        component: Layouts,
        children: [
            {
                path: '/home',
                name: 'Home',
                component: ViewHome,
            },
            {
                path: '/profile',
                name: 'Profile',
                component: ViewProfile,
            },
            {
                path: '/product',
                name: 'Product',
                component: ViewProduct,
            },
            {
                path: '/issue',
                name: 'Issue',
                component: ViewIssue,
            },
            {
                path: '/opc_block',
                name: 'Opc',
                component: ViewOpcBlock,
            },

        ],
    },


]

const router = new VueRouter({
    routes,
})

export default router
